import { COLORS } from "shared/consts";
import { toEm, toRem } from "shared/helpers";
import styled, { css } from "styled-components";

export const TableWrapper = styled.div`
  margin: 0 ${toRem(-16)};
  @media (width < ${toEm(992)}) {
    padding-bottom: ${toRem(56)};
  }
`;

export const LinkStyles = styled.div`
  display: flex;
  gap: ${toRem(8)};
  justify-content: space-between;
  &:not(:last-child) {margin-bottom: ${toRem(16)};}

  a {
    font-size: ${toRem(14)};
    color: ${COLORS.ACCENT.DEFAULT};
    cursor: pointer;

    @media (any-hover: hover){
      &:hover{
        text-decoration: underline;
      }
    }
  }
`

export const TableEditHeaderPopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
  background-color: ${COLORS.BG.ELEVATED};
`;

type TableEditHeaderPopoverItemProps = {
  $isActive: boolean;
}

export const TableEditHeaderPopoverItem = styled.div<TableEditHeaderPopoverItemProps>`
  margin: 0px ${toRem(12)} 0px ${toRem(12)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${toRem(8)};
  padding: ${toRem(8)} ${toRem(12)};
  font-size: ${toRem(14)};
  line-height: ${20 / 14};
  cursor: pointer;
  border-radius: ${toRem(8)};
  color: ${(props) =>
    props.$isActive ? COLORS.ACCENT.DEFAULT : COLORS.FG.DISABLED};

  ${(props) =>
    props.$isActive &&
    css`
      background-color: ${COLORS.ACCENT.CONTAINER_SOFT};
    `}
`;

export const TableAuthorWrapper = styled.div`
  max-width: 100%;
  .tagitem {
    padding: 0;
    pointer-events: none;
    max-width: 100%;

    &__label {
      display: flex;
      align-items: center;
      gap: ${toRem(8)};
      font-size: ${toRem(13)};
      line-height: ${16 / 13};
      max-width: 100%;
      flex: 0 0 100%;
      overflow: hidden;

      img {
        flex: 0 0 ${toRem(16)};
        width: ${toRem(16)};
        aspect-ratio: 1;
      }

      span {
        flex: 0 0 calc(100% - ${toRem(24)});
        max-width: calc(100% - ${toRem(24)});
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;

export const TableDictionariesWrapper = styled.div`
  display: flex;
  gap: ${toRem(4)};
  overflow: hidden;
  width: 100%;
  pointer-events: none;
`;

export const TableAttachmentsWrapper = styled.div`
  display: flex;
  gap: ${toRem(2)};
  width: 100%;
`;

export const TableAttachmentsItem = styled.div`
  width: ${toRem(16)};
  flex: 0 0 ${toRem(16)};
  aspect-ratio: 1;
  border-radius: ${toRem(4)};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  display: block;
  white-space: nowrap;

  &:has(span) {
    flex: 1 1 auto;
    width: auto;
    aspect-ratio: auto;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const TableMobileItem = styled.div`
  display: grid;
  grid-template-columns: ${toRem(36)} auto;
  gap: 0 ${toRem(12)};
  cursor: pointer;
  padding: ${toRem(10)} ${toRem(16)};
  transition: all 0.3s ease 0s;

  @media (any-hover: hover) {
    &:hover {
      background-color: ${COLORS.BG.SURFACE3};
    }
  }

  i {
    grid-row: 1 / span 2;
    width: ${toRem(36)};
    height: ${toRem(36)};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${toRem(8)};
    background-color: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  }

  div {
    font-size: ${toRem(14)};
    font-weight: 500;
    line-height: ${16 / 14};
  }

  span {
    color: ${COLORS.FG.MUTED};
    font-size: ${toRem(12)};
    line-height: ${16 / 12};
  }
`;

export const TableOldNewWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(2)};
  color: ${COLORS.FG.DEFAULT};

  span {
    color: ${COLORS.FG.DISABLED};
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: ${COLORS.BORDER.MUTED};
  margin: ${toRem(10)} 0 ${toRem(10)} 0;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  justify-content: center;
  gap: 8px;
`;
